module.exports = __webpack_public_path__ + "img/max-file-content-transfer.0d302e10.svg";